import {SyncHook} from '@baidu/ku-piper-core';

// 对外提供的hookName集合
export const HookNameMap = {
    BeforeDocRenderHook: 'BeforeDocRenderHook',
    AfterDocRenderHook: 'AfterDocRenderHook',
    BeforeHeaderRenderHook: 'BeforeHeaderRenderHook',
    BeforeKnowledgeRenderHook: 'BeforeKnowledgeRenderHook',
    BeforeHomeRenderHook: 'BeforeHomeRenderHook',
    AfterHomeRenderHook: 'AfterHomeRenderHook',
};

// 为了防止跟HookNameMap对不上，这里改成遍历生成了
export const HookMap = (function generateHookMap() {
    const map: {[key: string]: SyncHook} = {};
    Object.values(HookNameMap).forEach((key: string) => {
        map[key] = new SyncHook();
    });
    return map;
})();
